import { z } from "zod";

export const raw16Schema = z.string().regex(/^[0-9a-f]{32}$/u);

const timestampSchema = z.string().datetime({ offset: true });

export const linenOrderStatusSchema = z.enum([
  "CREATED",
  "DISPATCHED",
  "ACCEPTED",
  "PICKUP_CONFIRMED",
  "DELIVERED",
  "QC_COMPLETE",
  "CLOSED",
  "DECLINED",
  "CANCELLED",
]);

export const linenOrderSchema = z.strictObject({
  orderId: raw16Schema,
  checkoutRunId: raw16Schema,
  propertyId: raw16Schema,
  status: linenOrderStatusSchema,
  pickupAt: timestampSchema.nullable(),
  deliveryAt: timestampSchema.nullable(),
  versionNo: z.number().int().min(1),
  line1: z.string().nullable(),
  locality: z.string().nullable(),
  postalCode: z.string().nullable(),
  packageCode: z.string().nullable(),
  packageName: z.string().nullable(),
  itemSummary: z.string().nullable(),
});

export const linenOrderListResponseSchema = z.strictObject({
  status: z.literal("ok"),
  orders: z.array(linenOrderSchema),
});

export const linenOrderChangedResponseSchema = z.strictObject({
  status: z.enum(["changed", "unchanged"]),
});

export type LinenOrder = z.infer<typeof linenOrderSchema>;
export type LinenOrderStatus = z.infer<typeof linenOrderStatusSchema>;
